import React from 'react';
import { object, func, bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Language from '@material-ui/icons/Language';
import ExitToApp from '@material-ui/icons/ExitToApp';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import i18n from 'i18next';
import { Link } from 'react-router-dom';
import logoHeader from '../Images/eVisaLogo@2x.png';

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  appBar: {
    border: 0,
  },
  logo: {
    margin: 20,
  },
  appBarStyle: {
    opacity: 0.8,
  },
};

class Header extends React.Component {
  state = {
    auth: true,
    anchorEl: null,
    lang: 'en',
  };

  handleLangMenuPress = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLangChange = (lang) => () => {
    i18n.changeLanguage(lang);
    this.setState({ anchorEl: null, lang });
  };

  onLogout = () => {
    this.props.logout(this.props.history);
  };

  render() {
    const { classes, title, authenticated } = this.props;
    const { anchorEl, lang } = this.state;
    const open = Boolean(anchorEl);

    return (
      <div className={classes.root}>
        <AppBar
          className={classes.appBarStyle}
          position="absolute"
          color="inherit"
          elevation={0}
        >
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              {title}
            </Typography>
            <div>
              <IconButton
                aria-owns={open ? 'menu-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleLangMenuPress}
                color="inherit"
              >
                <Language />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleClose}
              >
                <MenuItem
                  onClick={this.handleLangChange('en')}
                  selected={lang === 'en'}
                >
                  English
                </MenuItem>
                <MenuItem
                  onClick={this.handleLangChange('fr')}
                  selected={lang === 'fr'}
                >
                  French
                </MenuItem>
                <MenuItem
                  onClick={this.handleLangChange('de')}
                  selected={lang === 'de'}
                >
                  German
                </MenuItem>
              </Menu>
            </div>
            {authenticated && (
              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : undefined}
                  aria-haspopup="true"
                  onClick={this.onLogout}
                  color="inherit"
                >
                  <ExitToApp />
                </IconButton>
              </div>
            )}
            <Link to={'/'}>
              <img
                className={classes.logo}
                src={logoHeader}
                alt="evisa website logo"
                height="45"
              />
            </Link>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: object.isRequired,
  logout: func.isRequired,
  authenticated: bool.isRequired,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/view/scenes/components/Header.js